export default "__VITE_ASSET__D4yqmyw1__"